const ChartDisplayEnum = {
    Percentage: "Percentage",
    Values: "Values"
}

export default ChartDisplayEnum;
